import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserService } from './user.service';

@Injectable()
export class AuthGuard implements CanActivate {
    constructor(private userService: UserService, private router: Router) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | Observable<boolean> | Promise<boolean> {
        let isAuth = this.userService.getIsAuth();
        const token = localStorage.getItem("token");
        if (token == null || token == 'null') {
            isAuth = false;
        }

        if(!isAuth) {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
        }
        return isAuth;
    }
}